import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CustomerRfqFeedState, RfqsQueryParameter, RfqsQuery } from "./models/models";
import customerCategoriesApi from "../shared/api/customerCategoriesApi";
import publicRfqsApi from "./api/publicRfqsApi";
import { ProductConditionCode } from "../../common/models/CommonModels";

export const getRfqs = createAsyncThunk(
  "customerRfqFeed/getRfqs",
  async (query: RfqsQuery) => {
    return publicRfqsApi.getRfqsAsync(query);
  }
);

export const getCategories = createAsyncThunk(
  "customerRfqFeed/getCategories",
  async () => {
    return customerCategoriesApi.getCategories();
  }
);

const initialState: CustomerRfqFeedState = {
  query: {
    search: undefined,
    sortBy: RfqsQueryParameter.created ,
    sortDesc: false,
    pageNo: 1,
    pageSize: 20,
    filterBy: undefined,
    conditionCodes: [
      ProductConditionCode.new,
      ProductConditionCode.used,
      ProductConditionCode.refit
    ],
    categoryId: undefined,
    urgencyCode: undefined
  },
  rfqs: undefined,
  rfq: undefined,
  categories: [],
  loading: false,
  success: undefined,
  error: undefined
};

const customerRfqFeedSlice = createSlice({
  name: "customerRfqFeed",
  initialState: initialState,
  reducers: {
    changeQuery: (state, action) => {
      state.query = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getRfqs.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRfqs.fulfilled, (state, { payload }) => {
        state.rfqs = payload;
        state.loading = false;
      })
      .addCase(getRfqs.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(getCategories.fulfilled, (state, { payload }) => {
        state.categories = payload;
      });
  }
});

export const {
  changeQuery,
  setSuccess,
  setError
} = customerRfqFeedSlice.actions;

export default customerRfqFeedSlice.reducer;